import { Directive, inject, input, OnDestroy, OnInit, output } from '@angular/core';
import { distinctUntilChanged, filter, map, Subject, takeUntil } from 'rxjs';
import { Rect } from '../../../classes/rect.class';
import { randomString } from '../../../lib/random-string';
import { DragDropService } from '../../../services/drag-drop.service';

@Directive({
  selector: '[appDragItem]',
  host: {
    '[attr.drag-item-id]': 'id()',
    '[attr.drag-item-uid]': 'uid',
    '[attr.drag-item-type]': 'type()',
    '[attr.drag-item-context]': 'context()',
  },
})
export class DragItemDirective implements OnInit, OnDestroy {
  private dragDropService = inject(DragDropService);
  uid = randomString(8);
  id = input<string>();
  context = input<string>();
  type = input.required<string>();

  dragging = output<boolean>();
  dropped = output<{
    id: string;
    type: string;
    target: string;
    targetType: string;
    position: Rect;
    offset: Rect;
    context: string;
  }>();

  destroyed$ = new Subject<void>();

  ngOnInit() {
    this.dragDropService.dragging$
      .pipe(
        takeUntil(this.destroyed$),
        filter(dragging => !dragging || dragging.triggered),
        map(dragging => {
          if (!dragging) return;
          return dragging.uid === this.uid;
        }),
        distinctUntilChanged()
      )
      .subscribe(dragging => {
        this.dragging.emit(dragging);
      });

    this.dragDropService.dropped$
      .pipe(
        takeUntil(this.destroyed$),
        filter(dropped => dropped && dropped.uid === this.uid)
      )
      .subscribe(dropped => {
        this.dropped.emit(dropped);
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
